module.exports = __webpack_public_path__ + "static/media/andu.1599e221.jpeg";